import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"get-code-cls amber lighten-1",on:{"click":function($event){return _vm.generate()}}},[_vm._v("Get Code")])
}
var staticRenderFns = []

export { render, staticRenderFns }